import dayjs from "dayjs";

const MSEC_IN_SECONDS = 1000;
const MSEC_IN_MINUTES = MSEC_IN_SECONDS * 60;
const MSEC_IN_HOURS = MSEC_IN_MINUTES * 60;

export default {
  methods: {
    getDate(date, format = "MMM D, YYYY") {
      return dayjs(date).format(format);
    },
    getTime(date, format = "h:mm A") {
      return dayjs(date).format(format);
    },
    getDateTime(date) {
      return `${this.getDate(date)} at ${this.getTime(date)}`;
    },
    getFormattedTimeDelta(aMsec, bMsec) {
      const { hours, minutes } = this.getTimeDelta(aMsec, bMsec);
      const formattedHours = hours == 1 ? `${hours} hour` : `${hours} hours`;
      const formattedMinutes =
        minutes == 1 ? `${minutes} minute` : `${minutes} minutes`;
      if (hours > 0) {
        return minutes > 0
          ? `${formattedHours} and ${formattedMinutes}`
          : formattedHours;
      }
      return formattedMinutes;
    },
    getTimeDelta(aMsec, bMsec) {
      let delta = aMsec - bMsec;
      const hours = Math.floor(delta / MSEC_IN_HOURS);
      delta -= hours * MSEC_IN_HOURS;
      const minutes = Math.floor(delta / MSEC_IN_MINUTES);
      delta -= minutes * MSEC_IN_MINUTES;
      const seconds = Math.ceil(delta / MSEC_IN_SECONDS);
      return { hours, minutes, seconds };
    }
  }
};
